export const getQueryString = (object: Record<string, any>): string => {
    const serializedObject: Record<string, any> = Object.entries(object).reduce((acc, entry) => {
        const [key, value] = entry;
        if (value === null || value === undefined) return acc;
        if (Array.isArray(value)) {
            if (!value.length) return acc;
            const serializedArrayValue = value.map((v, index) => {
                if (index === 0) return v;
                return `&${key}=${v}`;
            }).join("");
            acc[key] = serializedArrayValue;
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {} as Record<string, any>);
    return Object.entries(serializedObject).map(([key, value]) => `${key}=${value}`).join("&");
}

export const objectFromUrlSearchParams = (searchParams: URLSearchParams): Record<string, string> => {
    const entires = searchParams.entries();
    const result: Record<string, string> = {};
    for (const [key, value] of entires) {
        result[key] = value;
    }
    return result;
}

export type AnyObject = Record<string, any>;
export const getURLSearchParams = (value: AnyObject): URLSearchParams => {
    const entries = Object.entries(value);
    const searchParams = new URLSearchParams();
    for (const [key, value] of entries) {
        if (!value) continue;

        if (Array.isArray(value)) {
            for (const v of value) {
                searchParams.append(key, v);
            }
            continue;
        }
        searchParams.append(key, value);
    }
    return searchParams;
}